// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/DownloadAction/Content/Content/Download/Content/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Images_Content_Content_Content_Content_DownloadAction_Content_Content_Download_Content($id: numeric!) {
  vaxiom_image_series_download(image_series_id: $id) {
    url
    file_name
  }
}

`